import type { AxiosInstance } from 'axios';

export interface TranscriptReplacement {
  docPos: {
    from: number;
    to: number;
  };
  replacementText: string;
  expectedText: string;
  transcriptId: number;
}

export interface GlobalReplacement {
  replacementText: string;
  originalText: string;
  transcriptIds: number[];
  sourceEntities: {
    type: string;
    name: string;
  }[];
}

export interface ConfirmedTerm {
  term: string;
  transcriptIds: number[];
}

export interface SaveTranscriptReplacementsRequest {
  projectId: number;
  replacements: TranscriptReplacement[];
  globalReplacements: GlobalReplacement[];
  confirmedWords: ConfirmedTerm[];
  dictionaryWords: string[];
}

export interface SaveTranscriptReplacementsResponse {
  async: true;
  eventKey: string;
}

export class ProjectsTranscriptsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  saveTranscriptReplacements = ({ projectId, ...body }: SaveTranscriptReplacementsRequest) => {
    return this.authenticatedClient.post<SaveTranscriptReplacementsResponse>(
      `/projects/${projectId}/transcripts/replacements`, 
      body,
    ).then(res => res.data);
  };
}